module.exports = __webpack_public_path__ + "img/user-avatar.b94c1850.png";